import { gql } from '@apollo/client';

import { AppRequestFragment } from './appRequests.fragment';

export * from './appRequests.query.generated';

export const APP_REQUESTS = gql`
  query appRequests($kind: AppRequestsKindEnum!, $page: Int, $perPage: Int) {
    appRequests(kind: $kind, page: $page, perPage: $perPage) {
      nodesCount
      pagesCount
      nodes {
        ...AppRequestFragment
      }
    }
  }
  ${AppRequestFragment}
`;
